<template>
    <div>
        <div v-if="isshow">
            <el-form ref="form" :inline="true" :model="query" class="query-form" size="mini">
                <el-form-item label="关键词或热词榜单名：" class="query-form-item">
                    <el-input style="width: 200px;" clearable v-model="query.search" placeholder="请输入关键词或热词榜单名"></el-input>
                </el-form-item>
                <el-form-item label="站点：" class="query-form-item">
                    <el-select
                        v-model="query.state"
                        ref="carrerSelect"
                        style="width: 120px;"
                        size="mini"
                        filterable
                        clearable
                        @change="change"
                    >
                        <el-option
                            v-for="item in us_arr"
                            :key="item.us"
                            :label="item.title"
                            :value="item.us"
                            :disabled="item.disabled">
                            <div class="keywords_arr_div">
                                <icon-svg :icon-class="item.us" style="font-size: 24px;margin-right:5px;"></icon-svg>
                                <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" icon="el-icon-refresh" @click="onReset"></el-button>
                    <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
                    <el-button type="success" size="mini" @click="onCourse">教程</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                :data="list"
                size="mini"
                border
                style="width: 100%">
                <el-table-column
                    min-width="110"
                    align="center"
                    label="关键词">
                    <template slot-scope="scope">
                        <span>{{scope.row.keyword}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="110"
                    align="center"
                    label="热词榜单">
                    <template slot-scope="scope">
                        <span>{{scope.row.top_selling_list}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    align="center"
                    label="站点">
                    <template slot-scope="scope">
                        <span>{{scope.row.state}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    align="center"
                    label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.created_at}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="190">
                    <template slot-scope="scope">
                        <el-button type="success" size="mini" @click.native="viewData(scope.row)">查看详情</el-button>
                        <el-button @click="deleteKeyword(scope.row.id)" type="danger" size="mini" icon="el-icon-delete-solid">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                :page-size="query.limit"
                style="float: right;margin-top: 14px; margin-bottom: 10px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[20, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="query.total">
            </el-pagination>
        </div>
        <crx-view v-else></crx-view>
        <course :visible="ctrl.courseVisible" :title="'教程'" @close-callback="closeCllback"></course>
    </div>
</template>

<script>
import * as api from "@/api/analysis/analysis";
import CrxView from "@/components/crxView";
import Course from "./course";
import { checkPlug } from "@/utils/method";
export default {
    components: { CrxView, Course },
    data() {
        return {
            list: [],
            us_arr: [
                {
                    us: "US",
                    title: "美国"
                },
                {
                    us: "UK",
                    title: "英国"
                },
                {
                    us: "DE",
                    title: "德国"
                }
            ],
            formData: {},
            ctrl: {
                courseVisible: false
            },
            query: {
                page: 1,
                total: 0,
                limit: 20
            },
            loading: false,
            isshow: false
        };
    },
    created() {
        if (this.$route.query.page) {
            this.query.page = this.$route.query.page;
        }
        this.getList();
    },
    mounted() {
        checkPlug(()=>this.isshow = true, ()=>this.$downLoadPlug())
        let that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        150 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
        if (this.$route.query.data == null) return;
        api.add_asin(JSON.parse(this.$route.query.data)).then(res => {
            if (res.code === 0) {
                this.$alert(res.data, "系统提示", {
                    confirmButtonText: "确定",
                    callback: function() {
                        that.getList();
                        that.$router.push({ query: {} });
                    }
                });
            } else {
                this.$alert(res.message, "系统提示", {
                    confirmButtonText: "确定",
                    callback: function() {
                        that.$router.push({ query: {} });
                    }
                });
            }
        });
    },
    methods: {
        change() {
            this.getList();
        },
        //取数据
        getList() {
            this.loading = true;
            let obj = this.query;
            api.keyword_list(obj)
                .then(res => {
                    this.loading = false;
                    this.list = res.data.list;
                    this.query.total = res.data.total;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //删除关键词
        deleteKeyword(id) {
            this.$confirm("确定要删除这条数据记录吗?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.loading = true;
                    api.del_keyword({
                        id: id
                    })
                        .then(res => {
                            this.loading = false;
                            if (res.code === 0) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.getList();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                })
                .catch(() => {});
        },
        //查看详情
        viewData(data) {
            let url = "";
            if (data.keyword) {
                url =
                    "/marketAnalysis/list?id=" +
                    data.id +
                    "&keyword=" +
                    data.keyword +
                    "&page=" +
                    this.query.page;
            } else {
                url =
                    "/marketAnalysis/list?id=" +
                    data.id +
                    "&top_selling_list=" +
                    data.top_selling_list +
                    "&page=" +
                    this.query.page;
            }
            this.$router.push({
                path: url
            });
        },
        //教程
        onCourse() {
            this.ctrl.courseVisible = true;
        },
        //重置
        onReset() {
            this.query = {
                page: 1,
                limit: 20,
                total: 0
            };
            this.getList();
        },
        //查询
        onSubmit() {
            this.query.page = 1;
            this.getList();
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        //分页
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback() {
            this.ctrl.courseVisible = false;
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/ ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-track-piece {
    background-color: #ffff;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:horizontal {
    width: 7px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
</style>
